import { render } from "./DetailHeader.vue?vue&type=template&id=6c0cf326"
import script from "./DetailHeader.vue?vue&type=script&lang=js"
export * from "./DetailHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__